module.exports = __webpack_public_path__ + "img/icon4.4f404ce6.svg";